import React, { useMemo, useState } from "react";

import useSWR from "swr";

import useAuth from "../../../ContextProvider/AuthProvider";
import PawItemList from "../../Common/PawItemList.js";
import { Button, MenuItem, Select, Typography, Box } from "@mui/material";
import PawDataView from "../../Common/PawDataView.js";
// import EditIcon from "../../../Assets/Images/EditIcon.svg";
import Layout from "../../Side bar/Layout.js";
import ApiService from "../../../Api/ApiServices.js";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import AssignMembershipForm from "../../Forms/AssignMembershipForm";
import { ReactComponent as ViewIcon } from "../../../Assets/Images/viewIcon.svg";
import { ReactComponent as EditIcon } from "../../../Assets/Images/EditIcon.svg";
import { Modal } from "@mui/material";


import {
  ADMIN_ROLE,
  LOGIN_USER_ROLE_KEY,
  POWER_USER_ROLE,
  USER_ROLE_KEY,
} from "../../../Constant";
import { useTranslation } from "react-i18next";
import { hexToRgba } from "../../../Utils.js";
import { useTheme } from "@mui/material/styles";
import { showSnackbar } from "../../Common/Snackbar.js";


const numbersOfMembersOptions = Array.from({ length: 10 }, (_, i) => i + 1);

// let membersData2 = [];
export default function AccountInformation() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [selectedMembers, setSelectedMembers] = useState("");

  const { setUserId, setUser } = useAuth();
  const loginUserRole = localStorage.getItem(LOGIN_USER_ROLE_KEY);
  const navigate = useNavigate();
  const [AddInfo, setAddInfo] = useState({});
  const { t } = useTranslation();
  const theme = useTheme();

  const { data = [], mutate: fetchAccountInfo } = useSWR(
    `accountInfo`,
    async () => {
      const { data } = await ApiService.accountInfo();
      return data || [];
    },
    {
      revalidateOnFocus: false,
    }
  );




  const {
    data: membersData,
    mutate: fetchmembersData,
    isLoading: isMembersDataLoading,
  } = useSWR(
    `getMembershipCards`,
    async () => {
      setIsFetching(true);
      const { data } = await ApiService.getMembershipCards();
      setIsFetching(false);
      return data || [];
    },
    {
      revalidateOnFocus: false,
    }
  );

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const dataToSend = {
        count: selectedMembers
      }

      await ApiService.upgradeMember(dataToSend);
      showSnackbar({ type: 'success', message: `${t("screens.accountInformations.membershipAddedSuccessfully")}` });

      setIsModalOpen(false);
      setSelectedMembers("");
      fetchmembersData();
      fetchAccountInfo();

    } catch (err) {
      console.error(err, err.message);
      showSnackbar({ type: 'error', message: `${t("screens.accountInformations.membershipAddedErrorMessage")}` });
      // setSubmitting(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleView = async (item) => {

    const memberId = item?.user_id;

    if (!memberId) {
      showSnackbar({ type: 'error', message: `${t("screens.accountInformations.userDataNotFound")}` });
      return
    }
    try {
      setUserId(memberId);
      const { data } = await ApiService.getSelfInfo(memberId);
      if (data?.user_role) {
        localStorage.setItem(USER_ROLE_KEY, data?.user_role);
        setUser(item);
        navigate("/user-information");
      } else {
        showSnackbar({ type: 'error', message: `${t("screens.accountInformations.userDataNotFound")}` });
      }

    } catch (error) {
      showSnackbar({ type: 'error', message: `${t("screens.accountInformations.userDataNotFoundErrorMessage")}` });
    }
  };

  const handleEdit = (item) => {
    if (!item?.user_id) {
      return;
    }
    navigate(`/members/${item?.user_id}`);
  };

  const columns = useMemo(() => {
    return [
      {
        Header: `${t("screens.accountInformations.membershipID")}`,
        textAlign: "center",
        accessor: "membership_number",
        width: "12.5vw",
      },
      {
        Header: `${t("screens.accountInformations.accessCode")}`,
        textAlign: "center",
        accessor: "access_code",
        width: "12.5vw",
      },
      {
        Header: `${t("screens.accountInformations.name")}`,
        accessor: "name",
        textAlign: "center",
        width: "12.5vw",
        Cell: ({ row }) => {
          return !(row.original?.name === "null null" || row.original?.name === null) ? (
            <Typography
              sx={{
                padding: "5px",
                cursor: "pointer",
                fontSize: "12px",
                color: "#008fd3",
                ":hover": {
                  color: "red",
                },
              }}
              onClick={() => handleView(row.original)}
            >
              {row.original?.name}
            </Typography>
          ) : (
            <Typography
              sx={{
                padding: "5px",
                cursor: "pointer",
                fontSize: "12px",
                color: "#008fd3",
                ":hover": {
                  color: "red",
                },
              }}
              onClick={() => setAddInfo(row.original)}
            >
              {t("screens.accountInformations.assignMembership")}
            </Typography>
          );
        },
      },
      {
        Header: `${t("screens.accountInformations.email")}`,
        accessor: "user_email",
        textAlign: "center",
        width: "12.5vw",
      },
      {
        Header: `${t("screens.accountInformations.relationship")}`,
        accessor: "relation",
        textAlign: "center",
        width: "12.5vw",
      },
      {
        Header: `${t("screens.accountInformations.role")}`,
        accessor: "user_role",
        textAlign: "center",
        width: "12.5vw",
      },
      {
        Header: `${t("screens.formData.view")}`,
        accessor: "view",
        width: "4vw",
        textAlign: "center",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original?.name !== "null null" ? (
            <Button
              disabled={!row?.original?.user_id}
              sx={{
                minWidth: "40px",
                cursor: row?.original?.user_id ? "pointer" : "not-allowed !important",
                backgroundColor: hexToRgba(theme.palette.info.main, 0.1),
                '&.Mui-disabled': {
                  backgroundColor: hexToRgba(theme.palette.info.main, 0.07), // lighter when disabled
                  cursor: "not-allowed !important"
                },
                borderRadius: "10px",
                marginRight: "5px",
                width: "24px",
              }}
              onClick={() => handleView(row.original)}
            >
              <ViewIcon

                style={{
                  fill: `${row?.original?.user_id ? theme.palette.info.main : hexToRgba(theme.palette.info.main, 0.5)}`,
                  cursor: row?.original?.user_id ? "pointer" : "not-allowed !important",
                }}
                alt="view"
              />
            </Button>
          ) : (
            <></>
          );
        },
      },
      {
        Header: `${t("screens.formData.edit")}`,
        accessor: "edit",
        width: "4vw",
        textAlign: "center",
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original?.name !== "null null" ? (
            <Button
              disabled={!row?.original?.user_id || row?.original?.relation === 'Self'}
              sx={{
                minWidth: "40px",
                cursor: row?.original?.user_id || row?.original?.relation !== 'Self' ? "pointer" : "not-allowed !important",
                backgroundColor: hexToRgba(theme.palette.info.main, 0.1),
                '&.Mui-disabled': {
                  backgroundColor: hexToRgba(theme.palette.info.main, 0.07), // lighter when disabled
                  cursor: "not-allowed !important"
                },
                borderRadius: "10px",
                marginRight: "5px",
                width: "24px",
              }}
              onClick={() => handleEdit(row.original)}
            >
              <EditIcon
                style={{
                  fill: `${row?.original?.user_id || row?.original?.relation !== 'Self' ? theme.palette.info.main : hexToRgba(theme.palette.info.main, 0.5)}`,
                  cursor: row?.original?.user_id || row?.original?.relation !== 'Self' ? "pointer" : "not-allowed !important",
                }}
                alt="view"
              />
            </Button>
          ) : (
            <></>
          );
        },
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  const props = useMemo(() => ({
    label: "",
    isLoading: isMembersDataLoading || isFetching,
    columns,
    columnsData: membersData,
    details: " There are no details for this user.",
    isSelectHide: true,
    addButton: false,
  }), [isMembersDataLoading, membersData, isFetching, columns]);


  function isUnixDateFormat(date) {
    if (date) {
      const dateString = date.toString();
      const unixFormatRegex = /^\d+$/;
      return unixFormatRegex.test(dateString);
    }
  }

  const viewProps = {
    label: `${t("screens.accountInformations.accountInformation")}`,
    isShow: true,
    title2: `${t("screens.accountInformations.accountInformationMemberships")}`,
    detailsData: [
      [
        {
          name: `${t("screens.accountInformations.name")}`,
          value: data?.account?.user_fname ? `${data?.account?.user_fname} ${data?.account?.user_lname}` : "",
        },
        {
          name: `${t("screens.accountInformations.email")}`,
          value: data?.account?.user_email ? data?.account?.user_email : "",
        },
        {
          name: `${t("screens.accountInformations.role")}`,
          value: data?.account?.user_role ? data?.account?.user_role : "",
        },
        {
          name: `${t("screens.accountInformations.MemberSince")}`,
          value: data?.sum?.end_date
            ? isUnixDateFormat(data?.sum?.payment_date)
              ? moment(data?.sum?.payment_date * 1).format("MM/DD/YYYY")
              : moment(data?.sum?.payment_date).format("MM/DD/YYYY")
            : "",
        },
        {
          name: `${t("screens.accountInformations.ExpirationDate")}`,
          value: data?.sum?.end_date
            ? isUnixDateFormat(data?.sum?.end_date)
              ? moment(data?.sum?.end_date * 1).format("MM/DD/YYYY")
              : moment(data?.sum?.end_date).format("MM/DD/YYYY")
            : "",
        },
      ],
      [
        {
          name: `${t("screens.accountInformations.TotalMemberships")}`,
          value: data?.sum?.total_memberships ? data?.sum?.total_memberships : 0,
        },
        {
          name: `${t("screens.accountInformations.MembershipsUsed")}`,
          value: `${data?.sum?.total_memberships ? data?.sum?.total_memberships : 0} / ${data?.sum?.used_memberships ? data?.sum?.used_memberships : 0}`,
        },
      ],
    ],
  };



  return (
    <Layout>
      <PawDataView {...viewProps} />
      {!Object.keys(AddInfo).length && (
        <>
          {loginUserRole === ADMIN_ROLE && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <Button
                sx={{ height: "50px", width: "auto" }}
                style={{
                  backgroundColor: `${theme.palette.info.main}`,
                  color: "#FFFFFF",
                  margin: "0 25px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                  borderRadius: "10px",
                  cursor: "pointer",
                  marginLeft: "20px",
                }}
                onClick={() => {
                  // navigate("/settings/upgradeMembers");
                  setIsModalOpen(true)
                }}
              >
                {t("screens.rightSidebar.text.buyAdditionalMemberships")}
              </Button>
            </Box>
          )}
          {(loginUserRole === ADMIN_ROLE ||
            loginUserRole === POWER_USER_ROLE) && <PawItemList {...props} />}

          <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                width: "400px",
              }}
            >
              <Typography variant="h6">{t("screens.rightSidebar.text.selectNumberofMembers")}</Typography>
              <Select
                value={selectedMembers}
                onChange={(e) => setSelectedMembers(e.target.value)}
                displayEmpty
                fullWidth
                style={{ margin: "10px 0" }}
              >
                <MenuItem value="" disabled>
                  {t("screens.rightSidebar.text.selectNumberofMembers")}
                </MenuItem>
                {numbersOfMembersOptions.map((num) => (
                  <MenuItem key={num} value={num}>
                    {num}
                  </MenuItem>
                ))}
              </Select>
              <Button
                sx={{ height: "50px", width: "auto" }}
                style={{
                  backgroundColor: `${theme.palette.info.main}`,
                  color: "#FFFFFF",
                  // margin: "8px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                  borderRadius: "10px",
                  cursor: "pointer",
                  width: "100%",
                  opacity: `${!selectedMembers ? "0.7" : 1}`

                }}
                disabled={!selectedMembers}
                onClick={onSubmit}
              >
                {isLoading ? t("screens.formData.loading") : t("screens.formData.save")}
              </Button>
            </div>

          </Modal>
        </>
      )}
      {(loginUserRole === ADMIN_ROLE || loginUserRole === POWER_USER_ROLE) &&
        Object.keys(AddInfo).length > 0 && (
          <AssignMembershipForm
            data={AddInfo}
            setAddInfo={setAddInfo}
            fetchAPIData={fetchmembersData}
            fetchAccountInfo={fetchAccountInfo}
          />
        )}
    </Layout>
  );
}
